'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'rotate-left';
var width = 512;
var height = 512;
var aliases = ["rotate-back","rotate-backward","undo-alt"];
var unicode = 'f2ea';
var svgPathData = 'M124.8 122.9C155.7 96.2 196 80 240 80c97.2 0 176 78.8 176 176s-78.8 176-176 176c-39.7 0-76.2-13.1-105.6-35.2c-10.6-8-25.6-5.8-33.6 4.8s-5.8 25.6 4.8 33.6C143 463.3 189.6 480 240 480c123.7 0 224-100.3 224-224S363.7 32 240 32C182.7 32 130.4 53.5 90.8 88.9L60.3 58.3C53.7 51.7 44.7 48 35.3 48C15.8 48 0 63.8 0 83.3V200c0 13.3 10.7 24 24 24H140.7c19.5 0 35.3-15.8 35.3-35.3c0-9.4-3.7-18.3-10.3-25l-40.8-40.8zm-76.8-9L110.1 176H48V113.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRotateLeft = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;